import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGraduate, faEnvelope, faBookmark, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { BASE_NAME } from "../../routes";

const CustomButton = ({withLink, link, icon, color, withModal, handleOpen, member, copyToClipboard, setOpenSnackbar, email}) => {
    
    if (withModal) {
        return (
            <button
                type="button"
                style={{backgroundColor: `${color}`}}
                className={`text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1`}
                onClick={() => {
                    handleOpen(member)
                }}
                >
                {withLink ? (
                    <a href={link} target="_blank nonerreferer">
                    <FontAwesomeIcon icon={icon} />
                    </a>
                ) : (
                    <FontAwesomeIcon icon={icon} />
                )}
            </button>
        )
    } else if (copyToClipboard) {
        return (
            <button
                type="button"
                style={{backgroundColor: `${color}`}}
                className={` text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1`}
                onClick={() =>  {
                    navigator.clipboard.writeText(email);
                    setOpenSnackbar(true);
                }}
                >
                {withLink ? (
                    <a href={link} target="_blank nonerreferer">
                    <FontAwesomeIcon icon={icon} />
                    </a>
                ) : (
                    <FontAwesomeIcon icon={icon} />
                )}
            </button>
        )
    } else {
        return (
            <button
                type="button"
                style={{backgroundColor: `${color}`}}
                className={`text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1`}
                >
                {withLink ? (
                    <a href={link} target="_blank nonerreferer">
                    <FontAwesomeIcon icon={icon} />
                    </a>
                ) : (
                    <FontAwesomeIcon icon={icon} />
                )}
            </button>
        )
    }      
}

const MemberCard = ({member, handleOpen, setOpenSnackbar}) => {
    const { t } = useTranslation('global')
    const translationPrefix = 'About'

    return (
        <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
            <div className="px-6">
                <img
                    alt="..."
                    src={`${BASE_NAME}/img/${t(`${translationPrefix}.${member}.img`)}`}
                    className="shadow-lg rounded-full mx-auto max-w-200-px"
                />
                <div className="pt-6 text-center">
                <h5 className="text-xl font-bold">{t(`${translationPrefix}.${member}.name`)}</h5>
                <div className="flex flex-row items-center justify-center">
                    <p className="mt-1 text-md text-blueGray-500 font-semibold">
                        {t(`${translationPrefix}.${member}.job`)}
                    </p> 
                    {
                        member === 'lorenae' &&
                        <p className="ml-2 mt-1 text-md text-blueGray-500 font-bold">
                            ({t(`${translationPrefix}.${member}.coordinator`)})
                        </p>             
                    }
                </div>
                <div className="mt-4 mb-6">
                    {
                        t(`${translationPrefix}.${member}.cvuy`) !== '' &&
                        <CustomButton withModal={false} withLink={true} link={t(`${translationPrefix}.${member}.cvuy`)} icon={faUserGraduate} color={'#3C59C6'}/>
                    }
                    <CustomButton copyToClipboard={true} setOpenSnackbar={setOpenSnackbar} email={t(`${translationPrefix}.${member}.email`)} withModal={false} withLink={false} icon={faEnvelope} color={'#405075'} />
                    {
                        t(`${translationPrefix}.${member}.dblp`) !== '' &&
                        <CustomButton withModal={false} withLink={true} icon={faBookmark} color={'#5E72E4'} link={t(`${translationPrefix}.${member}.dblp`)} />   
                    }
                    {
                        t(`${translationPrefix}.${member}.pubs.pub1.name`) !== '' &&
                        <CustomButton member={member} handleOpen={handleOpen} withModal={true} withLink={false} icon={faPlus} color={'#002B8E'} />
                    }
                </div>
                </div>
            </div>
        </div>
    );
}

export default MemberCard;